module.exports = __webpack_public_path__ + "img/logo-educacross.8d11341e.png";